import { FOLDERS_PER_PAGE } from 'hb-react/frontoffice/apps/MediaCenter/container/utils/rendererConstants';
import { PARENT_TYPES } from 'hb-react/shared/constants/parentTypes';

// Api calls
export const fetchFilesUrl = ({ folderUuid, currentNetwork, topic }) =>
  Routes.media_center_v2_folder_files_path(folderUuid || 'root', {
    mediable_type: topic ? PARENT_TYPES.TOPIC : PARENT_TYPES.NETWORK,
    mediable_id: topic ? topic.id : currentNetwork.id,
  });

export const fetchFileUrl = (fileUuid) =>
  Routes.media_center_v2_file_path(fileUuid);

export const fetchFolderUrl = (folderUuid) =>
  Routes.media_center_v2_folder_path(folderUuid);

export const fetchFoldersUrl = ({
  folderUuid,
  currentNetwork,
  breakpoint,
  topic,
}) =>
  Routes.media_center_v2_folder_folders_path(folderUuid || 'root', {
    mediable_type: topic ? PARENT_TYPES.TOPIC : PARENT_TYPES.NETWORK,
    mediable_id: topic ? topic.id : currentNetwork.id,
    per_page: FOLDERS_PER_PAGE[breakpoint],
  });
